// src/pages/Login.js
import React, { useState, useContext } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Heading,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { ApplicationContext } from "../../utils/contextsProviders";
import axios from "axios";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const toast = useToast();
  const navigate = useNavigate();
  const { setUser } = useContext(ApplicationContext)

  const token = localStorage.getItem("token");

  if (token) {
    navigate("/");
  }

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/login`,
        {
          email,
          password,
        },
        {
          withCredentials: true, // ✅ important
        }
      );
      const { token } = response.data;
      const decoded = jwtDecode(token);
      setUser(decoded.user);
      // Save token to local storage
      localStorage.setItem("token", token);

      toast({
        title: "Login successful.",
        description: "You have successfully logged in.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      // Redirect to homepage
      navigate("/");
    } catch (error) {
      toast({
        title: "Error logging in.",
        description: error.response
          ? error.response.data.message
          : "Server error.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box
      minH="86.8vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.100"
      gap={0}
    >
      <Box bg="white" p={10} rounded="sm" boxShadow="md" width={600}>
        <Heading mb={6} textAlign="center">
          Login
        </Heading>
        <form onSubmit={handleLogin}>
          <Stack spacing={5}>
            <FormControl id="email" isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>
            <FormControl id="password" isRequired>
              <FormLabel>Password</FormLabel>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </FormControl>
            <Button
              bgColor={"grey"}
              color={"white"}
              borderRadius={"2px"}
              p={7}
              type="submit"
            >
              Login
            </Button>
          </Stack>
        </form>
      </Box>
    </Box>
  );
};

export default Login;
